import http from '../http'

export default {
  getChats () {
    return http.get('/chat')
  }
}
